/* unplugin-vue-components disabled */import { render } from "./PriceDisplayer.vue?vue&type=template&id=5bf15116"
import script from "./PriceDisplayer.vue?vue&type=script&lang=js"
export * from "./PriceDisplayer.vue?vue&type=script&lang=js"

import "./PriceDisplayer.vue?vue&type=style&index=0&id=5bf15116&lang=scss"
script.render = render

export default script